import { AppColors } from "@/assets/colors";
import { pxToRem } from "@/util";
import { investData } from "@/util/types";
import { Box, Typography } from "@mui/material";
import Image from "next/image";
import React from "react";
import { makeStyles } from "tss-react/mui";

export default function WhyReason({ mainImg, reasons }: Partial<investData>) {
  const { classes } = styles();

  return (
    <Box className={`${classes.container}`}>
      <Box className={` ${classes.imgCont}`}>
        <Image
          src={mainImg || "/images/home/contractor.svg"}
          fill
          style={{ objectPosition: "center", objectFit: "cover" }}
          alt={"Shield tick image"}
        />
      </Box>
      <Box className={` ${classes.det}`}>
        {reasons &&
          reasons.map((data, index) => (
            <Box key={index} className={`${classes.card}`}>
              <Box className={classes.cardImg}>
                <Image
                  src={`/images/service/${data.img}`}
                  fill
                  style={{ objectFit: "cover" }}
                  alt="Shield tick image"
                />
              </Box>
              <Box className={classes.desc}>
                <Typography className={classes.deschead}>
                  {data.head}
                </Typography>
                <Typography className={classes.descdet}>{data.desc}</Typography>
              </Box>
            </Box>
          ))}
      </Box>
    </Box>
  );
}

const styles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flexDirection: "row",
    flex: 1,
    paddingTop: theme.spacing(2),
    height: pxToRem(658),
    gap: pxToRem(50),
    marginTop: theme.spacing(5),

    [theme.breakpoints.down("md")]: {
      height: "auto",
      flexDirection: "column",
      gap: theme.spacing(4),
      marginTop: `0px`,
    },
  },
  imgCont: {
    flex: 1,
    position: "relative",
    display: "flex",
    borderRadius: pxToRem(8),
    overflow: "hidden",
    minHeight: pxToRem(320),

    [theme.breakpoints.down("md")]: {
      height: pxToRem(400),
      width: "100%",
    },
  },

  det: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    justifyContent: "flex-start",
    alignItems: "flex-start",
    [theme.breakpoints.down("md")]: {
      gap: theme.spacing(3),
    },
  },
  card: {
    height: pxToRem(166),
    borderRadius: pxToRem(8),
    border: `1px solid ${AppColors.neutral["70"]}`,
    display: "flex",
    gap: theme.spacing(3),
    padding: theme.spacing(3),
    alignItems: "flex-start",

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      height: "auto",
      alignItems: "flex-start",
      textAlign: "left",
    },
  },
  desc: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    flex: 1,
    alignItems: "flex-start",
  },

  cardImg: {
    position: "relative",
    width: pxToRem(68),
    height: pxToRem(68),

    [theme.breakpoints.down("sm")]: {
      width: pxToRem(56),
      height: pxToRem(56),
    },
  },
  deschead: {
    fontSize: pxToRem(20),
    fontWeight: 600,

    [theme.breakpoints.down("sm")]: {
      fontSize: pxToRem(19),
      fontWeight: "bold",
    },
  },
  descdet: {
    color: AppColors.text.second,
    fontWeight: 500,
    fontSize: pxToRem(16),
    width: "80%",

    [theme.breakpoints.down("sm")]: {
      width: "100%",
      fontSize: pxToRem(16),
      fontWeight: 500,
    },
  },
}));
